__turbopack_context__.v({
  "dealName": "dealName-module-scss-module__s0H-jG__dealName",
});
